import { ArrowLeft } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { useNavigate } from "react-router-dom";
import welcomeBg from "../../assets/homebg.png";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="scrollbar-hide relative mx-auto w-full max-w-[400px] bg-background"
      style={{
        minHeight: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Blurred Background Image */}
      <div
        className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-md"
        style={{
          backgroundImage: `url(${welcomeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-background/80" />

      <div
        className="scrollbar-hide relative z-10 space-y-5 overflow-y-auto p-4 pb-20"
        style={{ height: "calc(100vh - 0px)" }}
      >
        {/* Header */}
        <div className="flex items-center gap-4 pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="rounded-xl bg-card/80 shadow-md hover:bg-card"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold text-foreground">Privacy Policy</h1>
        </div>

        {/* Content Card */}
        <Card className="space-y-5 rounded-2xl border border-border bg-card p-6 shadow-lg">
          {/* Last Updated */}
          <p className="text-xs italic text-muted-foreground">
            Last updated: December 2025
          </p>

          <div className="pt-2">
            <h3 className="mb-2 text-base font-bold text-foreground">
              Information We Collect
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              We collect information you provide directly, including your name,
              email, health metrics, meal logs, and fitness data. We also
              collect usage data to improve our services.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              How We Use Your Information
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              Your information is used to provide personalized health insights,
              track your progress, and improve the Bite Balance experience. We
              never sell your personal data to third parties.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Data Storage & Security
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              Your data is encrypted and stored securely. We implement
              industry-standard security measures to protect your personal
              health information from unauthorized access.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Third-Party Services
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              We integrate with third-party services like Fitbit for enhanced
              functionality. These integrations are optional and governed by
              their respective privacy policies.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Your Rights
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              You have the right to access, correct, or delete your personal
              data at any time. Contact us at privacy@bitebalance.com for any
              privacy-related requests.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Data Retention
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              We retain your data as long as your account is active. You may
              request deletion of your account and all associated data at any
              time through the app settings.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Contact Us
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              For questions about this privacy policy, contact us at
              privacy@bitebalance.com.
            </p>
          </div>
        </Card>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground/70">
          © 2026 Bite Balance. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
